import { render, staticRenderFns } from "./GatherRecord.vue?vue&type=template&id=27ed39af&scoped=true&"
import script from "./GatherRecord.vue?vue&type=script&lang=js&"
export * from "./GatherRecord.vue?vue&type=script&lang=js&"
import style0 from "./GatherRecord.vue?vue&type=style&index=0&id=27ed39af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed39af",
  null
  
)

export default component.exports